<app-card-table [info]="info" (refresh)="onRefresh()">
  <div corporate-email-checkbox style="display: flex; align-items: center; justify-content: flex-end;">
    <input
      type="checkbox"
      [(ngModel)]="corporateEmailChecked"
      [disabled]="corporateEmailDisabled"
      (change)="onCorporateEmailCheckboxChange($event)"
      style="margin-right: 8px; width: 18px; height: 18px;"
    />
    <!-- Modal/Popup for Email Input -->
    <div *ngIf="showEmailDialog" class="modal-overlay">
      <div class="modal-content">
        <h4>Manual Email Verification</h4>
        <div style="margin-bottom: 12px;">
          <div class="email-lookup-row">
            <input
              class="email-lookup-input"
              [(ngModel)]="newEmail"
              placeholder="Enter user email"
              [disabled]="updatingEmail"
            />
            <button
              type="button"
              class="email-lookup-btn"
              (click)="lookupEmailDomain()"
              [disabled]="updatingEmail || domainTypeLookupLoading || !canLookupEmail()"
            >
              <span *ngIf="domainTypeLookupLoading" class="email-lookup-spinner" aria-label="Loading"></span>
              <span *ngIf="!domainTypeLookupLoading">Lookup</span>
            </button>
          </div>
          <label style="display: block; margin-bottom: 12px;">
            Domain type
            <select [(ngModel)]="domainType" [disabled]="updatingEmail || domainTypeLookupLoading" style="width: 100%; margin-top: 4px;">
              <option value="" disabled>Select domain type</option>
              <option *ngFor="let option of domainTypeOptions" [value]="option">{{ option }}</option>
            </select>
          </label>
          <div>
            <button (click)="submitEmail()" [disabled]="updatingEmail || domainTypeLookupLoading || !newEmail || !domainType" style="margin-right: 8px;">Submit</button>
            <button (click)="closeEmailDialog()" [disabled]="updatingEmail">Cancel</button>
          </div>
        </div>
        <span *ngIf="updatingEmail" style="margin-left: 8px;">Updating...</span>
        <div *ngIf="errorMsg" style="color: red; margin-top: 4px;">{{ errorMsg }}</div>
      </div>
    </div>
  </div>
</app-card-table>
